import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { inr, inrCompact, num } from "@/lib/format";
import { PageHeader } from "@/components/PageHeader";
import { ChartCard, MultiLine, Bars } from "@/components/Charts";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Earnings() {
  const [charts, setCharts] = useState(null);
  const [weekly, setWeekly] = useState([]);
  const [sort, setSort] = useState("total");
  const nav = useNavigate();

  useEffect(() => {
    api.get("/dashboard/charts").then(({ data }) => setCharts(data));
    api.get("/performance/weekly").then(({ data }) => setWeekly(data));
  }, []);

  const sorted = [...weekly].sort((a, b) => b[sort] - a[sort]);

  return (
    <div>
      <PageHeader title="Earnings & Performance" subtitle="Daily trends and weekly delivery-partner performance" />
      {charts && <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <ChartCard title="Orders vs Earnings" subtitle="Last 30 days"><MultiLine data={charts.daily} x="date" dualAxis lines={[{ key: "orders", name: "Orders" }, { key: "earnings", name: "Earnings ₹" }]} /></ChartCard>
        <ChartCard title="Incentives Earned" subtitle="Daily rain + incentive"><Bars data={charts.daily} x="date" y="incentives" color="#F59E0B" /></ChartCard>
      </div>}

      <div className="mt-6 overflow-hidden rounded-xl border border-border bg-card">
        <div className="flex items-center justify-between border-b border-border p-4">
          <h3 className="font-head text-sm font-semibold">Weekly Performance (this week)</h3>
          <div className="flex gap-1 text-xs">
            {[["total", "Earnings"], ["orders", "Orders"], ["incentives", "Incentives"]].map(([k, l]) => (
              <button key={k} onClick={() => setSort(k)} data-testid={`weekly-sort-${k}`} className={`rounded-md px-2.5 py-1 font-medium ${sort === k ? "bg-primary text-primary-foreground" : "bg-secondary text-muted-foreground"}`}>{l}</button>
            ))}
          </div>
        </div>
        <Table>
          <TableHeader><TableRow className="hover:bg-transparent"><TableHead>DP Name</TableHead><TableHead className="text-right">Orders</TableHead><TableHead className="text-right">Base</TableHead><TableHead className="text-right">Incentives</TableHead><TableHead className="text-right">Total</TableHead></TableRow></TableHeader>
          <TableBody>
            {sorted.map((r) => (
              <TableRow key={r.dp_id} className="cursor-pointer" onClick={() => nav(`/dp/${r.dp_id}`)} data-testid={`weekly-row-${r.dp_id}`}>
                <TableCell className="font-semibold">{r.name}</TableCell>
                <TableCell className="text-right tabular">{num(r.orders)}</TableCell>
                <TableCell className="text-right tabular">{inr(r.base)}</TableCell>
                <TableCell className="text-right tabular text-amber-500">{inr(r.incentives)}</TableCell>
                <TableCell className="text-right tabular font-bold text-emerald-500">{inr(r.total)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
